import React, { useState } from "react";
import { Switch, FormGroup, Tooltip, Icon, Notification } from 'xsolla-uikit';
import PAh2 from "../PAh2";
import { policies } from "./policies";

export function PArefundsBadge({
  level = "loyal",
  icon = true,
  product = 'game_store'
}) {
  const [on, setOn] = useState(true);

  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginLeft: -8 }}>
        <FormGroup indentation="sm">
          <Tooltip
            distance={4}
            offset="left"
            label={
              level === "strict" ? (
                <FormGroup indentation="md">
                  We are legally obliged to show this badge to the customer
                  before the purchase.
                </FormGroup>
              ) : (
                <FormGroup indentation="md">
                  The badge can promote the purchase.
                </FormGroup>
              )
            }
          >
            <Switch
              name="basic-switch"
              label="A customer will see this badge before the purchase"
              sublabel="For pre-orders the badge is always visible"
              disabled={level === "strict" ? true : false}
              input={{
                value: level === "strict" ? true : on,
                onChange: () => setOn(!on)
              }}
            />
            {/* <PAh2 tag='h5' title="The user will see this badge before the purchase"/> */}
          </Tooltip>
        </FormGroup>
      </div>
      <br />
      <FormGroup indentation="xs">
        <div
        style={{ height: 80 }}
        >
          {level === "loyal" && (
            <div className="xsbps_ref">
              <div className="xsbps_ref_icon">
                <div className="w-embed">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={40}
                    height={40}
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <g clipPath="url(#clip0)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.6746 2.95185C21.618 1.01428 24.7888 1.01605 26.7299 2.95717C28.0684 4.29564 28.4848 6.21881 27.9791 7.92107C28.1719 7.86691 28.3792 7.8375 28.5996 7.8375C29.1693 7.8375 29.7375 8.04431 30.1696 8.41738C30.5687 8.05722 31.0968 7.8375 31.6746 7.8375C32.9138 7.8375 33.9246 8.84829 33.9246 10.0875V15.3486C34.3628 15.102 34.8735 14.9625 35.4246 14.9625H36.9246V22.3875C36.9246 24.0664 36.3365 25.6466 35.3496 26.9625L35.3477 26.9651L33.2165 29.7813L33.1799 29.8178C33.0801 29.9176 33.0246 30.0322 33.0246 30.1875V37.4625L31.5377 37.6018L31.5758 29.7282L27.8496 9.84255V18.7125H26.3496V10.3982L24.8514 11.8964L24.9246 18.7044L23.4247 18.7206L23.3672 13.3805L19.6746 17.0732L12.6193 10.0178C10.6764 8.07494 10.6764 4.90006 12.6193 2.95717C14.5604 1.01605 17.7312 1.01428 19.6746 2.95185ZM27.8496 9.84255L29.4246 18.3488V10.0875C29.4246 9.67171 29.084 9.3375 28.5996 9.3375C28.2168 9.3375 27.897 9.41874 27.8496 9.84255ZM29.5076 18.7875L31.5758 29.7282C31.6603 29.3599 31.8434 29.047 32.0794 28.7981L34.1496 26.0625L34.1505 26.0613C34.963 24.9774 35.4246 23.7081 35.4246 22.3875V16.4625C34.5638 16.4625 33.9246 17.1017 33.9246 17.9625V22.3125H32.4246V10.0875C32.4246 9.67671 32.0854 9.3375 31.6746 9.3375C31.2638 9.3375 30.9246 9.67671 30.9246 10.0875V18.7875H29.5076ZM19.6746 4.0125L20.2049 4.54283L20.7299 4.01783C22.087 2.66072 24.3122 2.66072 25.6693 4.01783C27.0264 5.37494 27.0264 7.60006 25.6693 8.95717L19.6746 14.9518L13.6799 8.95717C12.3228 7.60006 12.3228 5.37494 13.6799 4.01783C15.037 2.66072 17.2622 2.66072 18.6193 4.01783L19.1443 4.54283L19.6746 4.0125Z"
                        fill="#5AC484"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.5 14.2123L21.9984 14.1641L22.8815 27.8508C23.0486 28.4247 23.2386 28.9901 23.4505 29.5445L23.5 29.6739V37.4623L22.0016 37.5106L21.395 28.1092C20.8095 26.0442 20.5 23.8789 20.5 21.7123V14.2123ZM30.175 22.4623C28.9392 22.4623 27.925 23.4766 27.925 24.7123H26.425C26.425 22.6481 28.1108 20.9623 30.175 20.9623H33.175V22.4623H30.175Z"
                        fill="#5AC484"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.9253 14.2123L17.4268 14.1641L16.5438 27.8508C16.3767 28.4247 16.1867 28.9901 15.9748 29.5445L15.9253 29.6739V37.4623L17.4237 37.5106L18.0303 28.1092C18.6158 26.0442 18.9253 23.8789 18.9253 21.7123V14.2123ZM9.25029 22.4623C10.4861 22.4623 11.5003 23.4766 11.5003 24.7123H13.0003C13.0003 22.6481 11.3145 20.9623 9.25029 20.9623H6.25029V22.4623H9.25029Z"
                        fill="#5AC484"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.196 7.92146C12.196 7.92146 11.7959 7.83789 11.5755 7.83789C11.0058 7.83789 10.4376 8.0447 10.0055 8.41777C9.60637 8.05762 9.07826 7.83789 8.50049 7.83789C7.26127 7.83789 6.25049 8.84868 6.25049 10.0879V15.349C5.81234 15.1024 5.30155 14.9629 4.75049 14.9629H3.25049V22.3879C3.25049 24.0668 3.83857 25.647 4.82549 26.9629L4.82744 26.9655L6.95862 29.7817L6.99516 29.8182C7.09495 29.918 7.15049 30.0326 7.15049 30.1879V37.4629L8.63744 37.6022L8.5993 29.7286L12.3255 9.84295V18.7129H13.8255V10.3986L15.3237 11.8968L15.2505 18.7048L16.7504 18.721L16.8079 13.3809L20.5005 17.0736L12.196 7.92146ZM12.3255 9.84295L10.7505 18.3491V10.0879C10.7505 9.6721 11.0911 9.33789 11.5755 9.33789C11.9583 9.33789 12.2781 9.41913 12.3255 9.84295ZM10.6675 18.7879L8.5993 29.7286C8.5148 29.3603 8.33171 29.0474 8.09569 28.7985L6.02549 26.0629L6.02457 26.0617C5.21206 24.9778 4.75049 23.7085 4.75049 22.3879V16.4629C5.61128 16.4629 6.25049 17.1021 6.25049 17.9629V22.3129H7.75049V10.0879C7.75049 9.67711 8.0897 9.33789 8.50049 9.33789C8.91127 9.33789 9.25049 9.67711 9.25049 10.0879V18.7879H10.6675Z"
                        fill="#5AC484"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          x="2.5"
                          y="1.5"
                          width={36}
                          height={36}
                          fill="white"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className="xsbps_right">
                <div className="xsbps_ref_h2">
                  <div>Flexible refund policy</div>
                </div>
                <p className="xsbps_ref_noti">
                  {policies[product]["presets"][level]["badge"]["text"]}
                </p>
              </div>
            </div>
          )}

          {level === "moderate" && (
            <div className="xsbps_ref xsbps_ref--yellow">
              <div className="xsbps_ref_icon">
                <div className="xsbps_ref_icon w-embed">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={40}
                    height={40}
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.671 8H25.749V18.5973L23.0494 15.8473L15.6255 23.4098L14.2757 22.0348V28.625H20.7452L19.3953 27.25L30.0455 16.3264L31 17.2986L21.3043 27.25L24.0039 30H12.9259V18.7152L15.6255 21.4652L23.0494 13.9027L24.3992 15.2777V9.375H17.9297L19.2796 10.75L7.95446 22.3611L7 21.3889L17.3706 10.75L14.671 8Z"
                      fill="#BC9531"
                    />
                    <path d="M35 34H33V36H35V34Z" fill="#BC9531" />
                    <path d="M35 30H33V32H35V30Z" fill="#BC9531" />
                    <path d="M35 26H33V28H35V26Z" fill="#BC9531" />
                    <path d="M31 34H29V36H31V34Z" fill="#BC9531" />
                    <path d="M31 30H29V32H31V30Z" fill="#BC9531" />
                    <path d="M27 34H25V36H27V34Z" fill="#BC9531" />
                    <path d="M4 6H6V4H4L4 6Z" fill="#BC9531" />
                    <path d="M4 10H6V8H4L4 10Z" fill="#BC9531" />
                    <path d="M4 14H6V12H4L4 14Z" fill="#BC9531" />
                    <path d="M8 6H10V4H8V6Z" fill="#BC9531" />
                    <path d="M8 10H10V8H8V10Z" fill="#BC9531" />
                    <path d="M12 6H14V4H12V6Z" fill="#BC9531" />
                  </svg>
                </div>
              </div>
              <div className="xsbps_right">
                <div className="xsbps_ref_h2">
                  <div>Moderate refund policy</div>
                </div>
                <p className="xsbps_ref_noti">
                  {policies[product]["presets"][level]["badge"]["text"]}
                </p>
              </div>
            </div>
          )}

          {level === "strict" && (
            <div className="xsbps_ref xsbps_ref--red">
              <div className="xsbps_ref_icon">
                <div className="xsbps_ref_icon w-embed">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={40}
                    height={40}
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M14.0562 4.76926L19.8335 9.88264L25.9155 4.76926H14.0562ZM27.5002 5.22757L19.8107 11.6923L12.8239 5.50864L9.61508 8.48834V12.3846H30.3843V8.11172L27.5002 5.22757ZM26.3911 17.1906L28.5442 15.3263C29.0675 14.8735 29.8582 15.3837 29.6609 16.0463L27.1907 24.3512C27.1482 24.4941 27.0607 24.6195 26.9412 24.7087C26.8217 24.7979 26.6766 24.8461 26.5275 24.8462H13.4719C13.3227 24.8463 13.1774 24.7981 13.0578 24.7089C12.9382 24.6197 12.8505 24.4942 12.808 24.3512L10.3379 16.047C10.144 15.3962 10.9062 14.8853 11.4352 15.3103L14.0645 17.4246L15.9926 15.1539L17.9685 17.0916L19.54 15.6932C19.6631 15.5839 19.8211 15.5221 19.9857 15.5188C20.1502 15.5155 20.3105 15.571 20.4379 15.6752L22.4705 17.3388L24.4997 15.1539L26.3911 17.1906ZM25.3208 18.117L24.4997 17.2329L23.5672 18.2367L24.3979 18.9166L25.3208 18.117V18.117ZM15.1695 18.3122L15.9192 18.9145L16.9175 18.0263L16.0965 17.2211L15.1695 18.3122ZM13.0766 3.38464H27.6151L31.7689 7.53849V13.7693H8.23047V7.88464L13.0766 3.38464ZM14.0597 23.4616H25.9819L27.6151 18.0207L24.8438 20.3988C24.721 20.5038 24.5654 20.5625 24.4039 20.5646C24.2424 20.5668 24.0852 20.5123 23.9597 20.4106L20.0399 17.2308L16.4537 20.3926C16.332 20.4995 16.1765 20.5602 16.0145 20.5641C15.8525 20.5681 15.6943 20.5149 15.5675 20.414L12.3843 17.8788L14.0597 23.4616ZM8.23047 26.2308H31.7689V34.5385L29.692 36.6154H10.6535L8.23047 34.1923V26.2308ZM9.61508 27.6154V33.6191L11.2268 35.2308H29.1188L30.3843 33.9653V27.6154H9.61508ZM22.7689 30.9883V27.6154H24.1535V31.6931L19.9997 34.5385L15.8459 31.6931V27.6154H17.2305V30.9883L19.9997 32.8853L22.7689 30.9883Z"
                      fill="#B66424"
                    />
                  </svg>
                </div>
              </div>
              <div className="xsbps_right">
                <div className="xsbps_ref_h2">
                  <div>Limited refund policy</div>
                </div>
                <p className="xsbps_ref_noti">
                  {policies[product]["presets"][level]["badge"]["text"]}
                </p>
              </div>
            </div>
          )}
        </div>
      </FormGroup>

      {/* <FormGroup indentation="sm">
      <Notification>For pre-orders the badge is always visible</Notification>

      </FormGroup> */}
    </div>
  );
}
